module.exports = ".tab-manager {\r\n\twidth:100%;\r\n}\r\n\r\n.tab-manager .tab {\r\n\tfloat:left;\r\n\tpadding: 4px 6px;\r\n\tborder: 1px #000000 solid;\r\n}\r\n\r\n.tab-manager .tab:hover {\r\n\tfloat:left;\r\n\tpadding: 4px 6px;\r\n\tborder: 1px #000000 solid;\r\n\tbackground-color: #E0E0E0;\r\n\tcursor: pointer;\r\n}\r\n\r\n.contentDiv{\r\n\twidth:100%;\r\n\tpadding: 4px 6px;\r\n\tmargin-top: -9px;\r\n\tmargin-left:8px;\r\n\tborder: 1px #000000 solid;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.css
// module id = ./src/app/dashboard/dashboard.component.css
// module chunks = main